import qs from 'qs';
import client from '@/api/base';

export default {
  async getLeaderPulseData(id) {
    const response = await client.get(`/coaching/leader/${id}/pulse/`);
    return response;
  },

  async extendLeaderPulseSurvey(id) {
    const response = await client.patch(`/coaching/leader/${id}/pulse/extend/`);
    return response;
  },

  async launchPulse(id) {
    const response = await client.patch(`/coaching/leader/${id}/pulse/launch/`);
    return response;
  },

  async closePulse(id) {
    const response = await client.patch(`/coaching/leader/${id}/pulse/close/`);
    return response;
  },

  async updatePulse(id, data) {
    const response = await client.patch(`/coaching/leader/${id}/pulse/`, data);
    return response;
  },

  async sendPulseReminder(id) {
    const response = await client.post(`/coaching/leader/${id}/pulse/send-reminder/`);
    return response;
  },

  // Coach's leaders
  async getCoachLeaders() {
    const response = await client.get('coaching/leader/');
    return response;
  },

  async getCoachLeaderDetails(id) {
    const response = await client.get(`coaching/leader/${id}/`);
    return response;
  },

  async getCoachLeaderAP(id) {
    const response = await client.get(`coaching/leader/${id}/ap/`);
    return response;
  },

  async getCoachLeaderFeedForwards(id) {
    const response = await client.get(`coaching/leader/${id}/ff/`);
    return response;
  },

  async getCoachLeaderProcess(id, params) {
    const response = await client.get(`coaching/leader/${id}/tasks/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async getCoachLeaderMeetingStatus(id) {
    const response = await client.get(`coaching/leader/${id}/meeting-status/`);
    return response;
  },

  async saveCoachTask(id, data) {
    const response = await client.patch(`coaching/leader/${id}/`, data);
    return response;
  },

  async saveLeaderGLA(id, data) {
    const response = await client.post(`coaching/leader/${id}/gla/`, data);
    return response;
  },

  // Leader Coworker
  async getLeaderCoworker(uuid) {
    const response = await client.get(`coaching/leader/${uuid}/coworker/`);
    return response;
  },

  async postLeaderCoworker(uuid, data) {
    const response = await client.post(`coaching/leader/${uuid}/coworker/`, data);
    return response;
  },

  async updateLeaderCoworker(leaderUuid, coworkerUuid, data) {
    const response = await client.patch(`coaching/leader/${leaderUuid}/coworker/${coworkerUuid}/`, data);
    return response;
  },

  async deleteLeaderCoworker(leaderUuid, coworkerUuid) {
    const response = await client.delete(`coaching/leader/${leaderUuid}/coworker/${coworkerUuid}/`);
    return response;
  },

  async publishLeaderCoworker(uuid) {
    const response = await client.post(`coaching/leader/${uuid}/coworker/confirm/`);
    return response;
  },

  // Leader Action plan
  async getLeaderLga(uuid) {
    const response = await client.get(`coaching/engagement/leader/${uuid}/lga/`);
    return response;
  },

  async getLeaderAp(uuid) {
    const response = await client.get(`coaching/engagement/leader/${uuid}/lga/ap/`);
    return response;
  },

  async getLeaderApNext(uuid) {
    const response = await client.get(`coaching/engagement/leader/${uuid}/lga/ap/next/`);
    return response;
  },

  async createLeaderActionPlan(uuid, data) {
    const response = await client.post(`coaching/engagement/leader/${uuid}/lga/ap/`, data);
    return response;
  },

  async createLeaderActionPlanNext(uuid, data) {
    const response = await client.post(`coaching/engagement/leader/${uuid}/lga/ap/next/`, data);
    return response;
  },

  async updateLeaderActionPlan(uuid, data) {
    const response = await client.patch(`coaching/engagement/leader/${uuid}/lga/ap/`, data);
    return response;
  },

  async updateLeaderActionPlanNext(uuid, data) {
    const response = await client.patch(`coaching/engagement/leader/${uuid}/lga/ap/next/`, data);
    return response;
  },

  async publishLeaderActionPlan(uuid, data) {
    const response = await client.post(`events/engagement/leader/${uuid}/lga/ap/publish/`, data);
    return response;
  },
};
